import { ClaraAuthPage } from "../components/ClaraAuthPage";

export const ForgotPasswordPage = () => {
  return <ClaraAuthPage type="forgotPassword" />;
};
